// src/components/YouTubeEmbed.js
import React, { useState, useEffect } from 'react';
import { parseYouTube, youtubeEmbedUrl, youtubeThumb } from '../utils/youtube';

/**
 * Reproductor de YouTube (video normal o Short) con carga diferida:
 * muestra la miniatura + botón de play; el iframe se monta SOLO al hacer clic.
 * Esto mejora el rendimiento (no carga el reproductor de YouTube hasta que el
 * socio quiere verlo) y respeta el ratio correcto según sea video o short.
 */
export default function YouTubeEmbed({ url, titulo = 'Video', autoPlayDelay = 0 }) {
  const [activo, setActivo] = useState(false);
  const info = parseYouTube(url);

  useEffect(() => {
    if (autoPlayDelay > 0 && info) {
      const t = setTimeout(() => setActivo(true), autoPlayDelay * 1000);
      return () => clearTimeout(t);
    }
  }, [autoPlayDelay, info]);

  if (!info) return null;
  const { id, esShort } = info;
  const ratioClase = esShort ? 'yt-ratio-short' : 'yt-ratio-video';

  return (
    <div className={`yt-embed ${ratioClase}`}>
      {activo ? (
        <iframe
          src={`${youtubeEmbedUrl(id)}?autoplay=1&mute=1&rel=0`}
          title={titulo}
          frameBorder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
        />
      ) : (
        <button
          type="button"
          className="yt-preview"
          onClick={() => setActivo(true)}
          aria-label={`Reproducir ${titulo}`}
          style={{ backgroundImage: `url(${youtubeThumb(id)})` }}
        >
          <span className="yt-play-btn" aria-hidden="true">▶</span>
        </button>
      )}
    </div>
  );
}